import { useEffect, useState } from 'react';
import { DataSyncObjectsStore } from '../stores/object/DataSyncObjectsStore';

export function useFetchStores(
  sourceStore: DataSyncObjectsStore | null,
  destinationStore: DataSyncObjectsStore | null
) {
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const [destinationLoaded, setDestinationLoaded] = useState(false);

  useEffect(() => {
    if (sourceStore) {
      setSourceLoaded(false);
      sourceStore.fetch().then(() => setSourceLoaded(true));
    }
    // null store: don't mark as loaded. The store may be null temporarily
    // while instance availability is resolving (e.g. HUB_APP). Once it
    // becomes non-null this effect re-runs and fetches.
  }, [sourceStore]);

  useEffect(() => {
    if (destinationStore) {
      setDestinationLoaded(false);
      destinationStore.fetch().then(() => setDestinationLoaded(true));
    }
  }, [destinationStore]);

  return {loaded: sourceLoaded && destinationLoaded};
}
